import { ADD_VAULT, FETCHING_VAULT, FETCHED_VAULT, UPDATE_VAULT_ENTRY, CLEAR_ALL } from '../constants';
import type { EncryptedCredential } from '../../utilities/vaultCrypto';

interface VaultState {
  list: Record<string, EncryptedCredential[]>;
  fetching: boolean;
  fetched: Record<string, number>;
}

const initialState: VaultState = {
  list: {},
  fetching: false,
  fetched: {},
};

export default function vaultReducer(
  state = initialState,
  { type, payload }: { type: string; payload?: any },
): VaultState {
  switch (type) {
    case CLEAR_ALL:
      return initialState;
    case ADD_VAULT:
      return {
        ...state,
        list: { ...state.list, [String(payload.project_id)]: payload.list },
      };
    case FETCHING_VAULT:
      return { ...state, fetching: payload };
    case FETCHED_VAULT:
      return { ...state, fetched: { ...state.fetched, [String(payload.project_id)]: Date.now() } };
    case UPDATE_VAULT_ENTRY: {
      // Patch a single credential's metadata fields in-place across all project lists.
      const { id, ...changes } = payload as { id: number; [key: string]: any };
      const updatedList: Record<string, EncryptedCredential[]> = {};
      for (const projectId of Object.keys(state.list)) {
        updatedList[projectId] = state.list[projectId].map((c) =>
          c.id === id ? { ...c, ...changes } : c,
        );
      }
      return { ...state, list: updatedList };
    }
    default:
      return state;
  }
}
